export class ShowHeaderAndFooter {
  static readonly type = '[Layout] ShowHeaderAndFooter';
}

export class HideHeaderAndFooter {
  static readonly type = '[Layout] HideHeaderAndFooter';
}

export class SetPostLoginRoute {
  static readonly type = '[Layout] SetPostLoginRoute';

  constructor(public payload: string) {}
}

export class LoadCategories {
  static readonly type = '[Layout] LoadCategories';

  constructor() {}
}

export class SetPreMobileMenuRoute {
  static readonly type = '[Layout] SetPreMobileMenuRoute';

  constructor(public payload: string) {}
}

export class Redirect {
  static readonly type = '[Layout] Redirect';

  constructor(public payload: { preRedirectionRoute: string; redirectionRoute: string }) {}
}

export class GoToPrevious {
  static readonly type = '[Layout] GoToPrevious';
}

export class ClearPreRedirectionRoute {
  static readonly type = '[Layout] ClearPreRedirectionRoute';
}

export class TriggerServerErrorFlagStart {
  static readonly type = '[Layout] TriggerServerErrorFlag';
}

export class TriggerServerErrorFlagDone {
  static readonly type = '[Layout] TriggerServerErrorFlag';
}

export class LoadBanners {
  static readonly type = '[Layout] LoadBanners';
}

export class LockBody {
  static readonly type = '[Layout] LockBody';
}

export class UnlockBody {
  static readonly type = '[Layout] UnlockBody';
}
